module.exports = __webpack_public_path__ + "static/media/how-it-works-4.ab8c91f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/how-it-works-4.png
// module id = 976
// module chunks = 0